import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { useMemo } from "react";
import { LoadingIndicator } from "../LoadingIndicator";
import { Typography } from "../Typography";

const LoadingOverlay = ({ message }: { message: string }) => {
  const scrollPos = useMemo(() => window.scrollY, []);

  return (
    <>
      {
        <Global
          styles={css`
            body {
              position: fixed;
              top: -${scrollPos}px;
              left: 0;
              right: 0;
            }
          `}
        />
      }
      <Layout>
        <Background></Background>
        <Modal>
          <div>
            <LoadingIndicator
              height={200}
              width={200}
              showLoadingMessage={false}
            />
          </div>
          <Typography variant="h2" style={{ color: "white" }}>
            {message}
          </Typography>
        </Modal>
      </Layout>
    </>
  );
};

const Background = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 33, 33, 0.8);
  z-index: 1000;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  animation-name: fadeIn;
  animation-duration: 0.2s;
  &.hide {
    @keyframes fadeOut {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
    animation-name: fadeOut;
    animation-duration: 0.23s;
  }
`;

const Modal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2em;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  padding: 4em;
  border-radius: 0.5em;
  z-index: 1001;
`;

const Layout = styled.div`
  position: fixed;
  left: calc(50% - 12em);
  top: calc(50% - 12em);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export { LoadingOverlay };
